import React, { Component } from 'react';
import { string, shape } from 'prop-types';
import axios from 'axios';

import { withCountryContext } from 'containers/withCountryContext';

import { langCode } from 'utils/currentLanguage';
import { PROVIDER_ID, tecDocUrl, basicAuth } from 'utils/constantsHelper';

import Loader from 'components/Loader';

export const getManufacturesInfoData = (WrappedComponent) => {
  return withCountryContext(
    class extends Component {
      constructor(props) {
        super(props);

        this.state = {
          loading: true,
          data: {},
        };
      }

      static propTypes = {
        brandId: string.isRequired,
        contextCountry: shape({
          currentCountry: string.isRequired,
        }).isRequired,
      };

      getData = (brandId) => {
        const requestBody = {
          getAmBrandAddress: {
            articleCountry: this.props.contextCountry.currentCountry,
            lang: langCode,
            brandNo: brandId,
            provider: PROVIDER_ID,
          },
        };

        axios
          .post(tecDocUrl, requestBody, { headers: { ...basicAuth } })
          .then((response) => {
            if (response.status === 200) {
              this.setState({
                data: response.data,
                loading: false,
              });
            }
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
          });
      };

      componentDidMount() {
        this.getData(this.props.brandId);
      }

      render() {
        if (this.state.loading) {
          return <Loader />;
        }

        return (
          <WrappedComponent
            data={this.state.data}
            loading={this.state.loading}
            {...this.props}
          />
        );
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/containers/ManufacturesInfoData/ManufacturesInfoData.js